export function roleLabel(item) {
    const role = item.user?.roles?.[0] || item.user?.assigned_role
    return role?.label || role?.name || '—'
}

export const LEVEL_LABELS = {
    novel: 'Novel',
    development: 'En Desarrollo',
    consolidated: 'Consolidado',
    field_trainer: 'Field Trainer',
}

export function levelLabel(level) {
    return LEVEL_LABELS[level] || level || '—'
}
